export const riskProfileModalTexts = {
	es: {
		header: "Información sobre los perfiles de riesgo",
		conservativeProfileTitle: "Perfil conservador",
		conservativeProfile:
			"Se caracteriza por buscar inversiones que representen un crecimiento\
        moderado, sin asumir riesgos importantes, priorizando tener una\
        disponibilidad inmediata de sus inversiones y buscando minimizar la\
        incidencia de las fluctuaciones del mercado.",
		moderateProfileTitle: "Perfil moderado",
		moderateProfile:
			"Se encuentra dispuesto a asumir ciertas oscilaciones en sus\
        inversiones, esperando que en un mediano / largo plazo pueda obtener\
        una mayor rentabilidad. Es un perfil intermedio, tratándose de\
        personas que pueden tolerar cierto riesgo en sus inversiones, a\
        cambio de una mayor rentabilidad.",
		aggressiveProfileTitle: "Perfil agresivo",
		aggressiveProfile:
			"Se caracteriza por inversores cuyo objetivo principal es maximizar\
        el rendimiento de su cartera, asumiendo para ello un alto componente\
        de riesgo. Están dispuestos a mantener sus inversiones por períodos\
        largos, sin asignarle una alta prioridad a la disponibilidad\
        inmediata de sus activos, y a asumir pérdidas de capital.",
		especulativeProfileTitle: "Perfil especulativo",
		especulativeProfile:
			"Un perfil especulativo en inversión se refiere a las características\
        y estrategias de un inversor que está dispuesto a asumir un mayor\
        nivel de riesgo en busca de posibles altos rendimientos.",
	},

	// TODO: These translations might be a bit sketch, confirm whether they're ok or not
	en: {
		header: "Information on risk profiles",
		conservativeProfileTitle: "Conservative profile",
		conservativeProfile:
			"Characterized by seeking moderate-growth investments without\
        assuming much risk, prioritizing inmediate availability of\
        investments and minimizing influence of market fluctuations",
		moderateProfileTitle: "Moderate profile",
		moderateProfile:
			"Is willing to assume certain oscillations in their investments in\
        the hope of obtaining better returns in the medium-to-long term. An\
        intermediate profile for those willing to tolerate limited risk in\
        exchange of better returns.",
		aggressiveProfileTitle: "Agressive profile",
		aggressiveProfile:
			"Characterized by investments made with the goal of maximizing their \
        portfolio's returns, assuming high risk for it. They're willing to\
        hold their positions for long periods of time, not considering\
        immediate availability of assets a high priority, while also \
        considering possible losses of capital",
		especulativeProfileTitle: "Especulative profile",
		especulativeProfile:
			"A speculative investment profile refers to the strategies and\
        characteristics of an investor willing to assume higher levels\
        of risk in seeking possibly higher returns.",
	},
};
